import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";
import { removeLinkFromAttr } from "./utils";

function handleEditProjectExternalLinkRequest(
  project: Identifiable<Project>,
  req: Boundaries["editProjectExternalLink"]["request"],
): Identifiable<Project> {
  return req.project.uuid === project.uuid
    ? {
        ...project,
        attributes: {
          ...removeLinkFromAttr(project.attributes, req.link),
          [`link.${req.nextLink.name}.url`]: req.nextLink.url,
          [`link.${req.nextLink.name}.name`]: req.nextLink.name,
        },
      }
    : project;
}

function handleEditProjectExternalLinkSuccess(
  project: Identifiable<Project>,
  req: Boundaries["editProjectExternalLink"]["success"],
): Identifiable<Project> {
  return req.project.uuid === project.uuid
    ? {
        ...project,
        attributes: {
          ...removeLinkFromAttr(project.attributes, req.link),
          [`link.${req.nextLink.name}.url`]: req.nextLink.url,
          [`link.${req.nextLink.name}.name`]: req.nextLink.name,
        },
      }
    : project;
}

function handleEditProjectExternalLinkFailure(
  project: Identifiable<Project>,
  req: Boundaries["editProjectExternalLink"]["failure"],
): Identifiable<Project> {
  return req.project.uuid === project.uuid
    ? {
        ...project,
        attributes: {
          ...removeLinkFromAttr(project.attributes, req.nextLink),
          [`link.${req.link.name}.url`]: req.link.url,
          [`link.${req.link.name}.name`]: req.link.name,
        },
      }
    : project;
}

export {
  handleEditProjectExternalLinkRequest,
  handleEditProjectExternalLinkSuccess,
  handleEditProjectExternalLinkFailure,
};
